// Keeps a scrollbar grown ("active") once the pointer touches the scrollbar itself, until the
// user clicks outside of its container. Styles live in `+scrollbar-styles`
// (`[data-scrollbar-active]`). Over a scrollbar, the scroll container is the event target.
const ATTRIBUTE = 'data-scrollbar-active';

const isOverScrollbar = (element: HTMLElement, { clientX, clientY }: PointerEvent) => {
  const isRoot = element === document.documentElement;
  const rect = isRoot
    ? { left: 0, top: 0, right: window.innerWidth, bottom: window.innerHeight }
    : element.getBoundingClientRect();

  // Content box edges; whatever lies beyond them (inside the border) is the scrollbar.
  const contentRight = rect.left + (isRoot ? 0 : element.clientLeft) + element.clientWidth;
  const contentBottom = rect.top + (isRoot ? 0 : element.clientTop) + element.clientHeight;
  const hasVerticalBar = contentRight < rect.right - (isRoot ? 0 : element.clientLeft);
  const hasHorizontalBar = contentBottom < rect.bottom - (isRoot ? 0 : element.clientTop);

  return (
    (hasVerticalBar && clientX >= contentRight) || (hasHorizontalBar && clientY >= contentBottom)
  );
};

document.addEventListener(
  'pointermove',
  (event) => {
    const target = event.target;

    if (
      target instanceof HTMLElement &&
      !target.hasAttribute(ATTRIBUTE) &&
      isOverScrollbar(target, event)
    ) {
      target.setAttribute(ATTRIBUTE, '');
    }
  },
  { passive: true },
);

document.addEventListener(
  'pointerdown',
  (event) => {
    const target = event.target as Node | null;

    document.querySelectorAll(`[${ATTRIBUTE}]`).forEach((element) => {
      if (!target || !element.contains(target)) element.removeAttribute(ATTRIBUTE);
    });
  },
  { passive: true, capture: true },
);
